import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { axiosMicro } from '~/services';
import { CustomSelectInput } from '../CustomSelectInput';

function fetchData(config) {
  return new Promise((resolve, reject) => {
    if (/^https?:\/\//.test(config.path)) {
      return axios.get(config.path).then((json) => resolve(json.data)).catch((err) => reject(err));
    }

    return axiosMicro.get(config.path).then((json) => resolve(json.data)).catch((err) => reject(err));
  });
}

export const SelectApi = ({
  name,
  config,
  value,
  onChange,
}) => {
  const [options, setOptions] = useState([]);
  const empty = {
    value: '',
    label: '---',
    key: '',
  };

  useEffect(() => {
    if (!config || !config.path || !config.object || !config.value || !config.title) {
      return;
    }

    const parseData = (json, object) => {
      try {
        if (object.length > 1) {
          return parseData(json[object[0]], object.slice(1));
        }

        return json[object[0]].map((item, index) => ({
          value: item[config.value].toString(),
          label: item[config.title],
          key: index,
        }));
      } catch {
        return [];
      }
    };

    fetchData(config).then(async (res) => {
      const list = await parseData(res, config.object.split('.'));
      setOptions(list);
    });
  }, [config]);

  const handleChange = (e) => {
    onChange(e.value);
  };

  return (
    <Select
      components={{ Input: CustomSelectInput }}
      className="react-select w-100"
      classNamePrefix="react-select"
      name={name}
      value={options.find((item) => item.value === value)}
      onChange={handleChange}
      options={[empty, ...options]}
    />
  );
};
